import { firebase } from "../firebase/firebase-config";

export const getItemFromArrayJsonPosition = (
  arraySearch: any,
  position: any,
  valueToSearch: any
) => {
  const foundPosition = arraySearch.find((element: any) => {
    return element[position] === valueToSearch;
  });
  return foundPosition;
};

export const getItemFromArrayJson = (arraySearch: any, position: any) => {
  const foundPosition = arraySearch.find((element: any) => {
    return element[position];
  });
  return foundPosition;
};

export const dateCheck = (start: string, end: string) => {
  const currentDate = new Date();
  let startDate, endDate;
  if (!iOS()) {
    startDate = Date.parse(start);
    endDate = Date.parse(end);
  } else {
    startDate = Date.parse(start.replace(/-/g, "/"));
    endDate = Date.parse(end.replace(/-/g, "/"));
  }

  // cDate = Date.parse(check);

  if (currentDate <= endDate && currentDate >= startDate) {
    return true;
  }
  return false;
};

function iOS() {
  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod"
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
    isMac
  );
}

export const dateCheckEndEvent = (end: any) => {
  const currentDate = new Date();
  let endDate;
  endDate = Date.parse(end);

  if (!iOS()) {
    endDate = Date.parse(end);
  } else {
    endDate = Date.parse(end.replace(/-/g, "/"));
  }

  if (currentDate >= endDate) {
    return true;
  }
  return false;
};

export const diferenceDates = (start: string, end: string) => {
  let fromTime = new Date();
  let toTime = new Date(end);

  let seconds = Math.abs(fromTime.getTime() - toTime.getTime()) / 1000;

  let days = Math.floor(seconds / 60 / 60 / 24);
  // days = days < 10 ? "" + days : days;

  let hour = Math.floor((seconds / 60 / 60) % 24);
  // let hour = Math.floor(seconds / 3600);
  // hour = hour < 10 ? "0" + hour : hour;
  let minute = Math.floor((seconds / 60) % 60);
  // let minute = Math.floor((seconds / 60) % 60);
  // minute = minute < 10 ? "0" + minute : minute;
  var second = Math.floor(seconds % 60);
  // let second = seconds % 60;
  // second = second < 10 ? "0" + second : second;
  return (
    (days > 0 ? days + "d - " : "") +
    (hour > 0 ? hour + "h - " : "") +
    minute +
    "m - " +
    second
  );
};

export const formatDateYYMMDD = (date: any) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const getToken = async () => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user: any) => {
      if (user) {
        user
          .getIdToken()
          .then(function(idToken) {
            resolve(idToken);
          })
          .catch(() => reject());
      } else {
        reject();
      }
    });
  });
};

export const showButton = (
  inscription,
  dateButtonValidation,
  limitParticipant,
  totalEnrolled
) => {
  let validate = true;
  if (inscription !== null) {
    // validate = false;
    return false;
  }
  if (dateButtonValidation) {
    return false;
  } else {
    validate = true;
  }
  if (limitParticipant !== null) {
    if (totalEnrolled < limitParticipant) {
      validate = true;
    } else {
      validate = false;
    }
  } else {
    validate = true;
  }

  return validate;
};
